import type React from 'react';

import type { IconProps } from 'types/icon';

const LongArrowRight: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M20.7639 12.1919L21.1817 11.7741L21.5996 12.1919L21.1817 12.6098L20.7639 12.1919ZM2.98429 12.7827C2.6577 12.7827 2.39355 12.5185 2.39355 12.1919C2.39355 11.8654 2.6577 11.6012 2.98429 11.6012V12.7875V12.7827ZM14.0737 4.66132L21.1865 11.7741L20.346 12.6146L13.2332 5.50179L14.0737 4.66132ZM21.1865 12.6098L14.0737 19.7226L13.2332 18.8821L20.346 11.7693L21.1865 12.6098ZM20.7639 12.7827H2.98429V11.5964H20.7639V12.7827Z"
        fill={color}
      />
    </svg>
  );
};

export default LongArrowRight;
